// extracted by css-extract-rspack-plugin
export default {"content":"content-l_GMJk flex justify-between items-center"};